import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: ${({ $readMode }) => ($readMode ? '1fr' : '1fr 40px')};
  justify-items: flex-start;
  gap: 5px;
  width: 100%;
  box-sizing: border-box;
  border-radius: var(--border-radius8);
  background-color: var(--color-greyEC);
  padding: 5px 5px 5px 10px;
`;

export const Text = styled.p`
  font-size: var(--font-size18);
  text-align: left;
  color: var(--color-grey6A);
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;
